/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Group_ConversationsInputs */

const en_us2_search_group_conversations = /** @type {(inputs: Search_Group_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const pt_br2_search_group_conversations = /** @type {(inputs: Search_Group_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas`)
};

const es_419_search_group_conversations = /** @type {(inputs: Search_Group_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversaciones`)
};

const pt_pt2_search_group_conversations = /** @type {(inputs: Search_Group_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas`)
};

const fr_fr2_search_group_conversations = /** @type {(inputs: Search_Group_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const de_de2_search_group_conversations = /** @type {(inputs: Search_Group_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltungen`)
};

const it_it2_search_group_conversations = /** @type {(inputs: Search_Group_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazioni`)
};

/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Search_Group_ConversationsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_group_conversations = /** @type {((inputs?: Search_Group_ConversationsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Group_ConversationsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_group_conversations(inputs)
	if (locale === "es-419") return es_419_search_group_conversations(inputs)
	if (locale === "pt-PT") return pt_pt2_search_group_conversations(inputs)
	if (locale === "fr-FR") return fr_fr2_search_group_conversations(inputs)
	if (locale === "de-DE") return de_de2_search_group_conversations(inputs)
	if (locale === "it-IT") return it_it2_search_group_conversations(inputs)
	return en_us2_search_group_conversations(inputs)
});
export { search_group_conversations as "search.group_conversations" }